import { AppLanguage } from 'app/config/i18Config/types';
import { LangSwitcherLanguage } from '../model/types';

export const appLanguages: LangSwitcherLanguage[] = [
  { value: AppLanguage.en, label: 'EN' },
  { value: AppLanguage.de, label: 'DE' },
  { value: AppLanguage.pl, label: 'PL' },
  { value: AppLanguage.ru, label: 'RU' },
];
